// export const BASE_URL = process.env.REACT_APP_BASE_URL;
 export const BASE_URL='https://apis.softpage.in/'
// export const BASE_URL='http://localhost:3003/'

export const PRODUCT = "product";
